import { render } from "./ResultsTableContainer.vue?vue&type=template&id=a28d635c"
import script from "./ResultsTableContainer.vue?vue&type=script&lang=js"
export * from "./ResultsTableContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__